var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAsterisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.21768 5.72722L2.31214 3.62921L0.542259 4.7677L0.000355095 3.8231L1.87962 2.86358L0.000355095 1.90406L0.542259 0.959461L2.31214 2.09796L2.21768 -5.57899e-05H3.29652L3.20206 2.09796L4.97195 0.959461L5.51385 1.90406L3.63459 2.86358L5.51385 3.8231L4.97195 4.7677L3.20206 3.62921L3.29652 5.72722H2.21768Z",
    fill: "#32AFB5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsterisk);
export default __webpack_public_path__ + "static/media/asterisk.fefe7a8a8ec5076c609d5aa5cf1eea32.svg";
export { ForwardRef as ReactComponent };